<template>
  <div>
    <div class="flex-center-between">
      <div class="title">商品中心</div>
      <!-- <el-button type="primary" icon="el-icon-s-promotion" class="sign-button mr20 fz15">发起签章</el-button> -->
      <div>

      </div>
    </div>

    <div class="seal-list">
      <div class="seal-item flex-dir-center">
        <img v-if="authenticationList.id && isExpire()" class="seal-revoke" src="@/assets/ic-authentication.png">
        <img v-if="authenticationList.id && !isExpire()" class="seal-revoke" src="@/assets/ic-expire.png">
        <div class="seal-area flex-dir">
          <img class="apply-img" src="@/assets/user/RSA.png" alt/>
          <div class="fz16 mt10">RSA数字证书</div>
        </div>
        <div class="seal-bottom flex-center-between">
          <div class="flex-center fc6 fz14 pointer seal-detail" @click="handleDetails"
               v-if="authenticationList.certInfo">
            <img class="icon-seal" src="@/assets/user/icon-more.png" alt="">
            详情
          </div>
          <div v-else></div>
          <el-dropdown trigger="click" @command="e => handleCommand(e)" class="pointer">
            <div class="flex-center fc6">
              <img class="icon-seal" src="@/assets/user/icon-setting.png" alt="">
              管理
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a" v-if="authenticationList.id"><i class="el-icon-setting"></i>默认配置项
              </el-dropdown-item>
              <el-dropdown-item command="b" v-if="!authenticationList.certInfo || !isExpire()"><i
                  class="el-icon-setting"></i>购买RSA认证
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="seal-item flex-dir-center">
        <div style="transform: rotate(35deg);" class="timestamp-number"
             v-if="timestampList.count && timestampList.count > 0">剩余{{ timestampList.count }}次
        </div>
        <div class="seal-area flex-dir">
          <img class="apply-img" src="@/assets/user/timeStamp.png" alt/>
          <div class="fz16 mt10">时间戳证书</div>
        </div>
        <div class="seal-bottom flex-center-between">
          <div class="flex-center fc6 fz14 pointer seal-detail" v-if="false">
            <img class="icon-seal" src="@/assets/user/icon-more.png" alt="">
            详情
          </div>
          <div v-else></div>
          <el-dropdown trigger="click" @command="e => handleCommand(e)" class="pointer">
            <div class="flex-center fc6">
              <img class="icon-seal" src="@/assets/user/icon-setting.png" alt="">
              管理
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="c" v-if="timestampList.count && timestampList.count > 0"><i
                  class="el-icon-setting"></i>默认配置项
              </el-dropdown-item>
              <el-dropdown-item command="d"><i class="el-icon-setting"></i>购买时间戳认证</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="seal-item flex-dir-center">
        <div style="transform: rotate(35deg);" class="timestamp-number"
             v-if="copiesList.count && copiesList.count > 0">剩余{{ copiesList.count }}次
        </div>
        <div class="seal-area flex-dir">
          <img class="apply-img" src="@/assets/user/copies.png" alt/>
          <div class="fz16 mt10">合同份数</div>
        </div>
        <div class="seal-bottom flex-center-between">
          <div class="flex-center fc6 fz14 pointer seal-detail" v-if="false">
            <img class="icon-seal" src="@/assets/user/icon-more.png" alt="">
            详情
          </div>
          <div v-else></div>
          <el-dropdown trigger="click" @command="e => handleCommand(e)" class="pointer">
            <div class="flex-center fc6">
              <img class="icon-seal" src="@/assets/user/icon-setting.png" alt="">
              管理
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="e"><i class="el-icon-setting"></i>购买次数</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="seal-item flex-dir-center">
        <div style="transform: rotate(35deg);" class="timestamp-number"
             v-if="gapDay() && gapDay() > 0">剩余{{ gapDay() }}天
        </div>
        <div class="seal-area flex-dir">
          <img class="apply-img" src="@/assets/user/client.png" alt/>
          <div class="fz16 mt10">PDF客户端签章</div>
        </div>
        <div class="seal-bottom flex-center-between">
          <div class="flex-center fc6 fz14 pointer seal-detail" v-if="false">
            <img class="icon-seal" src="@/assets/user/icon-more.png" alt="">
            详情
          </div>
          <div v-else></div>
          <el-dropdown trigger="click" @command="e => handleCommand(e)" class="pointer">
            <div class="flex-center fc6">
              <img class="icon-seal" src="@/assets/user/icon-setting.png" alt="">
              管理
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="f"><i class="el-icon-setting"></i>购买</el-dropdown-item>
              <el-dropdown-item command="g"><i class="el-icon-setting"></i>客户端下载</el-dropdown-item>
              <el-dropdown-item command="h"><i class="el-icon-setting"></i>用户手册下载</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

    </div>

    <default-option
        ref="defaultOption"
        :visible.sync="defaultVisible"
        @getServiceInfo="getServiceInfo"
    />

    <default-details
        ref="defaultDetails"
    />

    <r-s-a-detail ref="RSADetail" @getServiceInfo="getServiceInfo"/>


    <copies-details ref="copies"/>
  </div>
</template>

<script>
import DefaultOption from "@/pages/userCenter/components/defaultOption.vue";
import RSADetail from "@/pages/customerEnterprise/components/RSADetail.vue";
import DefaultDetails from "@/pages/userCenter/components/defaultDetails.vue";
import CopiesDetails from "@/pages/userCenter/components/copies-details.vue";

export default {
  name: "myProduct",
  components: {CopiesDetails, DefaultDetails, RSADetail, DefaultOption},
  data() {
    return {
      defaultVisible: false,
      loading: false,
      clientList: {},
      authenticationList: {},
      timestampList: {},
      copiesList: {},
    }
  },
  created() {
    this.getServiceInfo()
  },
  methods: {
    gapDay() {
      let days = this.$moment(this.clientList.expireTime).diff(this.$moment(), 'days')
      if (days > 0) {
        return days
      } else {
        return false
      }
    },
    isExpire() {
      return this.$moment().isBefore(this.authenticationList.certInfo?.notAfter)
    },
    handleDetails() {
      this.$refs.defaultDetails.show(this.authenticationList.certInfo)
    },
    getServiceInfo() {
      this.loading = true
      this.$http.get(this.$api.user.getServiceInfo,).then(res => {
        if (res.data.code == 200) {

          let params = res.data.data
          for (let i = 0; i < params.length; i++) {
            if (params[i].serviceType === 'RSA') {
              this.authenticationList = params[i]
            } else if (params[i].serviceType === 'timestamp') {
              this.timestampList = params[i]
            } else if (params[i].serviceType === 'copies') {
              this.copiesList = params[i]
            } else if (params[i].serviceType === 'client') {
              this.clientList = params[i]
            }
          }
          // this.authenticationList = res.data.data[0] ? res.data.data[0] : {}
          // this.loading = false
        }
      });
    },
    downLoad(url) {
      window.open(url);
    },
    handleCommand(command, item) {
      switch (command) {
        case "a":
          this.$refs.defaultOption.open(this.authenticationList, 'rsa')
          break;
        case "b":
          this.$refs.RSADetail.open(item, 'rsa')
          break;
        case "c":
          this.$refs.defaultOption.open(this.timestampList, 'timeStamp')
          break;
        case "d":
          this.$refs.RSADetail.open(item, 'timeStamp')
          break;
        case "e":
          this.$refs.copies.open(item,)
          break;
        case "f":
          this.$refs.RSADetail.open(item, 'pdfSign')
          break;
        case "g":
          this.downLoad('https://www.lngsyz.com/app/PDF签章客户端（企业新版）.exe')
          break;
        case "h":
          this.downLoad('https://www.lngsyz.com/app/PDF电子签章客户端(企业新版)操作手册.pdf')
          break;
      }

    },
  }
}
</script>

<style lang="less" scoped>
.title {
  border-top: 6px solid #407fff;
  width: 106px;
  font-weight: 400;
  font-size: 26px;
  color: #000;
  padding-top: 12px;
}

.seal-list {
  padding-top: 35px;

  .seal-item {
    position: relative;
    // display: block;
    width: 22%;
    height: 254px;
    margin: 0 3% 30px 0;
    float: left;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
    overflow: hidden;

    &:hover {
      scale: 1.05;
      box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
    }

    .seal-label {
      position: absolute;
      right: -5px;
      top: -4px;
      width: auto;
      z-index: 8;
      cursor: pointer;
    }

    .seal-ukey {
      position: absolute;
      right: 0;
      bottom: 43px;
      width: 32px;
      z-index: 8;
    }

    .seal-revoke {
      position: absolute;
      right: 0;
      top: 0;
      width: 64px;
      z-index: 8;
    }

    .timestamp-number {
      position: absolute;
      right: -22px;
      top: 12px;
      width: 100px;
      z-index: 8;
      color: #FFFFFF;
      font-size: 14px;
      background-color: #407fff;
    }

    .copies-number {
      position: absolute;
      right: -22px;
      top: 12px;
      width: 100px;
      z-index: 8;
      color: #FFFFFF;
      font-size: 14px;
      background-color: #407fff;
    }

    .seal-making {
      position: absolute;
      right: 0;
      top: 0;
      width: 48px;
      z-index: 8;
    }

    .apply-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 100%;
      border: 1px dashed #ebebeb;
      background: #f7faff;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        scale: 1.05;
        box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
      }
    }

    .apply-img {
      width: 51px;
    }

    .seal-area {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      border-bottom: 1px solid #ebebeb;
    }

    .seal-name {
      position: absolute;
      bottom: -25px;
    }

    .seal-bottom {
      padding: 10px 13px;
      width: 100%;

      .seal-detail:hover {
        color: red;
      }
    }

    .seal-img {
      width: 150px;
    }

    .icon-seal {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }
}
</style>
